import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import Utils from "../../configs/Utils";
import MailTemplateBlock from "../../Components/MailTemplates";

const MailTemplatesPage = () => {
  const { workspaceId } = useParams();

  useEffect(() => {
    Utils.setPageTitle("Mail Templates");
  }, []);

  return (
    <main className="page-main">
      <div className="main-container container">
        <div className="d-flex align-items-center p-3 my-3 text-white bg-primary rounded shadow-sm heading-box">
          <div className="d-flex align-items-center w-100">
            <FontAwesomeIcon
              className="me-3"
              fixedWidth
              size="xl"
              icon={faEnvelope}
            />
            <div className="lh-1">
              <h2 className="h6 mb-0 text-white lh-1">Mail Templates</h2>
              <small>Manage email templates for this workspace</small>
            </div>
          </div>
        </div>

        <MailTemplateBlock workspaceId={workspaceId} />
      </div>
    </main>
  );
};

export default MailTemplatesPage;
